export enum ProductBrand {
  Hively = 1,
  Astra,
}
